// extracted by mini-css-extract-plugin
module.exports = {"backButton":"NavBackButton-module__backButton___2YDSl","backButtonIcon":"NavBackButton-module__backButtonIcon___1m6xR"};